<template>
  <m-tooltip placement="left">
    <m-card-item
      no-hover
      :disabled="disabled"
    >
      <template #left>
        {{ $t('listFilter.limitFilterToFirstLevel') }}
      </template>
      <template #right>
        <m-select
          :items="applyFilterOnFirstLevelOnlyOptions"
          :value="value"
          light
          small
          hide-border
          :disabled="disabled"
          @input="updateApplyFilterOnFirstLevelOnly($event)"
        />
      </template>
    </m-card-item>
    <template #title>
      {{ $t('listFilter.limitFilterToFirstLevelDescription') }}
    </template>
  </m-tooltip>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:value']);

const applyFilterOnFirstLevelOnlyOptions = ref([
  {
    text: t('listFilter.allLevels'),
    value: false,
  },
  {
    text: t('listFilter.firstLevel'),
    value: true,
  },
]);
const updateApplyFilterOnFirstLevelOnly = (value) => {
  emit('update:value', value);
};
</script>
